import styled from "@emotion/styled";
import MKTypography from "components/MKTypography";

export const StyledTeamMemberName = styled(MKTypography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.dark?.main || "#1a1a1a",
  marginBottom: "0.25rem",
}));

export const StyledTeamMemberTitle = styled(MKTypography)(({ theme }) => ({
  color: theme.palette.accent.main,
  fontWeight: 500,
  fontSize: "0.95rem",
  letterSpacing: "0.3px",
}));

// Extract the ImageContainer cssProps as a constant function
export const teamMemberImageStyles = (theme) => ({
  borderRadius: "50%",
  border: `4px solid ${theme.palette.accent.main}`,
  width: "160px",
  height: "160px",
  objectFit: "cover",
  boxShadow: `0 4px 16px ${theme.palette.accent.main}20`,
  display: "flex",
  margin: "0 auto 1rem auto !important",
});
